import { AdapterInterface, ConverterInterface, Repository as BaseRepository } from '@cundd/rest-adapter';
import { ClassConstructorType } from '@cundd/rest-adapter/build/dist/ClassConstructorType';
import { Config } from './Config';
import { JobCenterModelInterface } from './Model/JobCenterModelInterface';

export class Repository<T extends JobCenterModelInterface> extends BaseRepository<T> {
    private _config: Config;

    constructor(
        targetType: ClassConstructorType<T>,
        resourceType: string,
        adapter: AdapterInterface,
        config: Config,
        converter?: ConverterInterface<T>
    ) {
        super(targetType, resourceType, adapter, converter);
        this._config = config;
    }

    public findAll(): Promise<T[] | Map<string, T>> {
        if (this._config.twoLetterIsoCode) {
            const filterByContextLanguage = (model: JobCenterModelInterface) => model.contextLanguage === this._config.twoLetterIsoCode;

            return super.findAll().then((ok: T[] | Map<string, T>) => {
                if (ok instanceof Map) {
                    return Array.from(ok.values()).filter(filterByContextLanguage);
                } else {
                    return ok.filter(filterByContextLanguage);
                }
            });
        } else {
            return super.findAll();
        }
    }

    //
    // public findByIdentifier(identifier: IdentifierInterface): Promise<T | null> {
    //     return this._adapter
    //         .findByIdentifier(this._resourceType, identifier)
    //         .then(result => this._converter.convertSingle(this._targetType, result as object | null));
    // }
    //
    // /**
    //  * Perform a GET or POST request to the given API path
    //  *
    //  * @param {string} subPath
    //  * @param {ExecuteMethod} method
    //  * @param {I} body
    //  * @return {Promise<T[] | Map<string, T> | T | null>}
    //  */
    // public execute<I, R = T[] | Map<string, T> | T | null>(
    //     subPath: string,
    //     method: ExecuteMethod = ExecuteMethod.GET,
    //     body?: I
    // ): Promise<R> {
    //     if (!(this._adapter instanceof RestAdapter)) {
    //         throw new TypeError('Not implemented');
    //     }
    //     const onFulfilled = (result: any): R => {
    //         if (Array.isArray(result)) {
    //             return this._converter.convertCollection(this._targetType, result) as any;
    //         } else {
    //             return this._converter.convertSingle(this._targetType, result) as any;
    //         }
    //     };
    //
    //     const requestPath = this._resourceType + '/' + subPath;
    //
    //     if (method === 'GET') {
    //         return this._adapter
    //             .execute(requestPath)
    //             .then(onFulfilled) as Promise<R>;
    //     } else if (method === 'POST') {
    //         if (arguments.length < 3) {
    //             throw new ReferenceError('Missing request body');
    //         }
    //
    //         return this._adapter
    //             .execute(requestPath, method, body)
    //             .then(onFulfilled) as Promise<R>;
    //     } else {
    //         throw new TypeError(`Method '${method}' is not implemented`);
    //     }
    // }
}
